(() => {
  const mobile = window.matchMedia('(max-width: 749px)');
  let sequence = 0;
  function initialise() {
    document.querySelectorAll('.collection-hero:not(.collection-hero--shop-all) .collection-hero__description').forEach(copy => {
      if (copy.dataset.disclosureReady) return;
      copy.dataset.disclosureReady = 'true';
      const children = Array.from(copy.children);
      const paragraphs = children.filter(node => node.tagName === 'P' && node.textContent.trim());
      // Only disclose structured multi-paragraph introductions, never clip text.
      if (paragraphs.length < 2 || children[0] !== paragraphs[0]) return;
      const extra = children.slice(1);
      if (extra.some(node => node.hidden)) return;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'category-intro__toggle';
      extra.forEach(node => {
        node.classList.add('category-intro__extra');
        if (!node.id) {
          let id;
          do { id = `category-intro-extra-${++sequence}`; }
          while (document.getElementById(id));
          node.id = id;
        }
      });
      button.setAttribute('aria-controls', extra.map(node => node.id).join(' '));
      let expanded = false;
      function update() {
        button.hidden = !mobile.matches;
        copy.classList.toggle('category-intro--collapsed', mobile.matches && !expanded);
        button.setAttribute('aria-expanded', String(expanded));
        button.textContent = expanded ? 'Read less ↑' : 'Read more ↓';
        extra.forEach(node => { node.hidden = mobile.matches && !expanded; });
      }
      button.addEventListener('click', () => {
        expanded = !expanded;
        update();
        if (!expanded && button.getBoundingClientRect().top < 0) button.scrollIntoView({ block: 'center' });
      });
      mobile.addEventListener('change', update);
      copy.after(button);
      update();
    });
  }
  initialise();
  document.addEventListener('shopify:section:load', initialise);
})();
